type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const RECORD_LIST_HEADERS: Header[] = [
  {
    key: 'documentTypeName',
    label: 'Document Type',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'senderKeyName',
    label: 'Sender',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'headerModifiedByName',
    label: 'Uploaded By',
    sortable: false,
    style: { width: '14%' },
  },
  {
    key: 'headerUpdatedDate',
    label: 'Uploaded On',
    sortable: false,
    style: { width: '14%' },
  },
  {
    key: 'dateOfAppointmentInfo',
    label: 'Appointment Date & Time',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'totalPageCount',
    label: 'Total Pages',
    sortable: false,
    style: { width: '12%', textAlign: 'right' },
    isNumeric: true,
  },
  {
    key: 'totalLineCount',
    label: 'Total Lines',
    sortable: false,
    style: { width: '12%', textAlign: 'right' },
    isNumeric: true,
  },
  {
    key: 'fileAction',
    label: 'File',
    sortable: false,
    style: { width: '5%' },
  },
  {
    key: 'actions',
    label: 'Action',
    style: { width: '10%' },
  },
];

export const RECORD_LIST_BY_SENDER_HEADERS: Header[] = [
  {
    key: 'documentTypeName',
    label: 'Document Type',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'documentCategory',
    label: 'Document Category',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'headerModifiedByName',
    label: 'Uploaded By',
    sortable: false,
    style: { width: '14%' },
  },
  {
    key: 'headerUpdatedDate',
    label: 'Uploaded On',
    sortable: false,
    style: { width: '14%' },
  },
  {
    key: 'dateOfAppointmentInfo',
    label: 'Appointment Date & Time',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'totalPageCount',
    label: 'Total Pages',
    sortable: false,
    style: { width: '12%', textAlign: "right" },
    isNumeric: true,
  },
  {
    key: 'totalLineCount',
    label: 'Total Lines',
    sortable: false,
    style: { width: '12%', textAlign: 'right' },
    isNumeric: true,
  },
  {
    key: 'fileAction',
    label: 'File',
    sortable: false,
    style: { width: '5%' },
  },
  {
    key: 'actions',
    label: 'Action',
    style: { width: '10%' },
  },
];

export const RECORD_LIST_HEADERS_VIEW: Header[] = [
  {
    key: 'documentTypeName',
    label: 'Document Type',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'senderKeyName',
    label: 'Sender',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'headerModifiedByName',
    label: 'Uploaded By',
    sortable: false,
    style: { width: '16%' },
  },
  {
    key: 'headerUpdatedDate',
    label: 'Uploaded On',
    sortable: false,
    style: { width: '15%' },
  },
  {
    key: 'dateOfAppointmentInfo',
    label: 'Appointment Date & Time',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'totalPageCount',
    label: 'Total Pages',
    sortable: false,
    style: { width: '10%', textAlign: "right" },
    isNumeric: true,
  },
  {
    key: 'totalLineCount',
    label: 'Total Lines',
    sortable: false,
    style: { width: '12%', textAlign: 'right' },
    isNumeric: true,
  },
  {
    key: 'fileAction',
    label: 'File',
    sortable: false,
    style: { width: '5%' },
  },
];

export const RECORD_LIST_BY_SENDER_HEADERS_VIEW: Header[] = [
  {
    key: 'documentTypeName',
    label: 'Document Type',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'documentCategory',
    label: 'Document Category',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'headerModifiedByName',
    label: 'Uploaded By',
    sortable: false,
    style: { width: '16%' },
  },
  {
    key: 'headerUpdatedDate',
    label: 'Uploaded On',
    sortable: false,
    style: { width: '15%' },
  },
  {
    key: 'dateOfAppointmentInfo',
    label: 'Appointment Date & Time',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'totalPageCount',
    label: 'Total Pages',
    sortable: false,
    style: { width: '10%', textAlign: "right" },
    isNumeric: true,
  },
  {
    key: 'totalLineCount',
    label: 'Total Lines',
    sortable: false,
    style: { width: '12%', textAlign: 'right' },
    isNumeric: true,
  },
  {
    key: 'fileAction',
    label: 'File',
    sortable: false,
    style: { width: '5%' },
  },
];

export const FILE_HEADERS: Header[] = [
  {
    key: 'fileName',
    label: 'File Name/Version No',
    sortable: false,
    style: { width: '30%' },
  },
  {
    key: 'description',
    label: 'Description',
    sortable: false,
    style: { width: '32%' },
    //   style: {width: '15%'},
  },
  {
    key: 'uploadedByName',
    label: 'Uploaded By',
    sortable: false,
    style: { width: '18%' },
  },
  {
    key: 'uploadDateTimeNew',
    label: 'Uploaded On',
    sortable: false,
    style: { width: '15%' },
  },
  {
    key: 'download',
    label: 'Action',
    style: { width: '10%' },

    //style: {width: '6%'},
  },
];

export const VERSION_HEADER: Header[] = [
  { label: 'File Name/Version No', key: 'revisionNoDesc', style: { width: '25%' } },
  { label: 'Description', key: 'description' },
  { label: 'Uploaded By', key: 'uploadedByName' },
  { label: 'Uploaded On', key: 'uploadDateTimeNew' },
  { label: 'Action', key: 'download' },
];

export const VERSION_HEADER_EDIT: Header[] = [
  { label: 'File Name', key: 'revisionNoDesc', style: { width: '25%' } },
  { label: 'Description', key: 'description' },
  { label: 'Pages', key: 'noOfPages' },
  { label: 'Action', key: 'download' },
];

export const VERSION_HEADER_EDIT_TRANSC: Header[] = [
  { label: 'File Name', key: 'revisionNoDesc', style: { width: '25%' } },
  { label: 'Description', key: 'description' },
  { label: 'Pages', key: 'noOfPages' },
  { label: 'Lines', key: 'totalLineCount' },
  { label: 'Action', key: 'download' },
];

export const RECORD_LIST_ATTACHMENT_HEADERS: Header[] = [
  {
    key: 'documentTypeName',
    label: 'Document Type',
    sortable: false,
    style: { width: '30%' },
  },
  {
    key: 'documentCategory',
    label: 'Document Category',
    sortable: false,
    style: { width: '30%' },
  },
  {
    key: 'fileName',
    label: 'File Name',
    sortable: false,
    style: { width: '20%' },
  },

  {
    key: 'uploadedByName',
    label: 'Uploaded By',
    sortable: false,
    style: { width: '14%' },
  },




  {
    key: 'Attachmentactions',
    label: 'Action',
    style: { width: '10%' },
  },
];
export const RECORD_LIST_ATTACHMENT_BY_SENDER_HEADERS: Header[] = [
  {
    key: 'documentTypeName',
    label: 'Document Type',
    sortable: false,
    style: { width: '30%' },
  },
  {
    key: 'senderKeyName',
    label: 'Sender Name',
    sortable: false,
    style: { width: '30%' },
  },
  {
    key: 'fileName',
    label: 'File Name',
    sortable: false,
    style: { width: '20%' },
  },
  {
    key: 'uploadedByName',
    label: 'Uploaded By',
    sortable: false,
    style: { width: '14%' },
  },


  {
    key: 'Attachmentactions',
    label: 'Action',
    style: { width: '10%' },
  },
];